<style lang="scss" scoped>
section {
  width: 1920px;
  height: 1080px;
}
div {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <section :style="containerStyle" class="container">
    <div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isPortrait: window.innerHeight > window.innerWidth,
      containerStyle: {}
    };
  },
  methods: {
    setSize() {
      this.isPortrait = window.innerHeight > window.innerWidth;
      const appWidth = 1920;
      const appHeight = 1080;
      const widthRatio = window.innerWidth / appWidth;
      const heightRatio = window.innerHeight / appHeight;

      if (widthRatio < heightRatio) {
        let trans = `scale(${widthRatio})`;
        this.containerStyle = {
          transform: trans
        };
        window.scaleRatio = widthRatio;
      } else {
        let trans = `scale(${heightRatio})`;
        this.containerStyle = {
          transform: trans
        };
        window.scaleRatio = heightRatio;
      }
    }
  },
  mounted() {
    this.setSize();
    const events = ["orientationchange", "resize"];
    events.forEach(ev =>
      window.addEventListener(ev, () => {
        this.setSize();
      })
    );
    window.dispatchEvent(new Event("resize"));
  }
};
</script>
